module.exports = __webpack_public_path__ + "img/00049.538e485c.webp";